<template>
  <legacy-cta-after-impression v-if="loadState === 'failed'" />
  <ds-audience-cta v-else :loading="loadState === 'loading'" />
</template>

<script>
import Sentry, { featureTags } from '../../3rd-parties/sentry'
import { loadAudienceDesignSystem } from '../../utils/designSystemLoader'
import AudienceCTA from './AudienceCTA.vue'
import DsAudienceCTA from './DsAudienceCTA.vue'

const LOAD_TIMEOUT_MS = 4000

// DsAudienceCTA has already counted this view, so the fallback must not count it twice.
const LegacyCtaAfterImpression = {
  extends: AudienceCTA,
  beforeMount() {
    this._impressionFired = true
  },
}

export default {
  components: { LegacyCtaAfterImpression, DsAudienceCta: DsAudienceCTA },
  data() {
    return { loadState: 'loading' }
  },
  async mounted() {
    this.loadTimer = setTimeout(() => this.fallBackToLegacy(new Error('design system load timed out')), LOAD_TIMEOUT_MS)
    try {
      await loadAudienceDesignSystem()
      if (this.loadState === 'loading') this.loadState = 'ready'
    } catch (error) {
      this.fallBackToLegacy(error)
    } finally {
      clearTimeout(this.loadTimer)
    }
  },
  beforeDestroy() {
    clearTimeout(this.loadTimer)
  },
  methods: {
    fallBackToLegacy(error) {
      if (this.loadState !== 'loading') return
      // A blocked CDN must not cost the learner Retake, Review or Feedback.
      this.loadState = 'failed'
      Sentry.captureException(error, {
        extra: { message: 'load design system failed' },
        tags: featureTags({ featureFlag: 'AHA-49118-replay', featureName: 'audience-footer', taskId: 'SEPA-22' }),
      })
    },
  },
}
</script>
